@if (isOpen) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-3 py-4 sm:px-5"
    aria-modal="true"
    role="dialog"
    aria-labelledby="submit-exam-heading"
    (click)="onClose()"
  >
    <article
      class="w-full max-w-xl overflow-hidden rounded-md bg-white shadow-2xl"
      (click)="$event.stopPropagation()"
    >
      <div class="flex items-center justify-between bg-brand-primary px-4 py-2">
        <h2 id="submit-exam-heading" class="secondary-label font-semibold text-white">
          Submit Examination
        </h2>
        <button
          type="button"
          class="flex h-8 w-8 items-center justify-center text-3xl leading-none text-white transition hover:opacity-80"
          aria-label="Close submit examination popup"
          (click)="onClose()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="px-3 py-2 sm:px-6 sm:py-4">
        <p class="text-xl font-bold text-mock-gray-900">
          Are you sure you want to submit?
        </p>

        <div class="mt-4 overflow-hidden rounded-xl border border-slate-300">
          @for (row of summaryRows; track row.label) {
            <div class="flex items-center justify-between gap-4 border-b border-mock-gray-200 bg-white px-4 py-3 last:border-b-0 odd:bg-mock-gray-50">
              <span class="text-base font-inter font-semibold text-mock-gray-900">{{ row.label }}</span>
              <span class="text-base font-inter font-bold text-mock-gray-900" [class]="row.valueClass">{{ row.value }}</span>
            </div>
          }
        </div>

        <p class="mt-4 text-sm font-medium font-inter text-mock-orange-900">
          Note: Questions marked for review will also be evaluated.
        </p>

        <div class="mt-8 flex flex-col gap-3 sm:flex-row">
          <div class="w-full sm:w-1/2">
            <app-outline-button
              text="Cancel"
              buttonClass="w-full rounded-md text-sm py-3 px-4"
              ariaLabel="Cancel submit examination"
              (buttonClick)="onClose()"
            />
          </div>
          <div class="w-full sm:w-1/2">
            <app-primary-button
              text="Submit"
              buttonClass="w-full rounded-md text-sm px-4 py-3"
              ariaLabel="Confirm submit examination"
              (buttonClick)="onSubmit()"
            />
          </div>
        </div>
      </div>
    </article>
  </div>
}
